import { useEffect, useRef, useState } from 'react';
import { AxiosError } from 'axios';
import { ICriteriaRating } from '../interfaces';
import { getCriteriaRatingsByServiceType } from '../api';

export function useGetCriteriaRatings(serviceTypeId?: number, onLoad?: (data: ICriteriaRating[]) => void) {
  const [{ loading, data, error }, setData] = useState<{
    loading: boolean;
    error: string | null;
    data: ICriteriaRating[];
  }>({ loading: false, error: null, data: [] });

  // Запоминаем уже загруженный serviceTypeId, чтобы не перезапрашивать критерии при повторном заходе.
  const loadedServiceTypeId = useRef<number | undefined>(undefined);

  const fetchCriteriaRatings = async () => {
    setData((prevState) => ({ ...prevState, loading: true }));

    try {
      const response = await getCriteriaRatingsByServiceType(serviceTypeId!);
      setData((prevState) => ({ ...prevState, data: response }));
      onLoad?.(response);
    } catch (error) {
      loadedServiceTypeId.current = undefined;
      setData((prevState) => ({
        ...prevState,
        data: [],
        error: (error as AxiosError).response?.data.message,
      }));
    } finally {
      setData((prevState) => ({ ...prevState, loading: false }));
    }
  };

  useEffect(() => {
    if (!serviceTypeId || loadedServiceTypeId.current === serviceTypeId) return;

    loadedServiceTypeId.current = serviceTypeId;
    fetchCriteriaRatings();
  }, [serviceTypeId]); // eslint-disable-line react-hooks/exhaustive-deps

  return { loading, data, error, fetchCriteriaRatings };
}
